import { render } from "./AboutProductHistory.vue?vue&type=template&id=473ac660&scoped=true"
import script from "./AboutProductHistory.vue?vue&type=script&lang=js"
export * from "./AboutProductHistory.vue?vue&type=script&lang=js"

import "./AboutProductHistory.vue?vue&type=style&index=0&id=473ac660&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473ac660"]])

export default __exports__